<ng-template #loadingBlock>
    <div class="center spinner-container">
        <div class="spinner-wrapper">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-template>
<div *ngIf="getCurrentUser()">
    <iframe *ngIf="isReady && iframeUrl else loadingBlock" [src]="iframeUrl" height="100%" width="100%"></iframe>
</div>
